// extracted by mini-css-extract-plugin
export default {"pip_container":"fas_pip_container","pip_item":"fas_pip_item","pip_icon":"fas_pip_icon"};